import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {apiUrl} from "../../environments/environment";
import {PhaseGroup} from "../_models/phase";
import {Observable} from "rxjs";
import {Page} from "../_models/page";

@Injectable({
  providedIn: 'root'
})
export class PhaseGroupService {

  constructor(private http: HttpClient) { }

  getAllPhaseGroupBySection(sectionId: number) {
    return this.http.get<PhaseGroup[]>(`${apiUrl}/section/${sectionId}/phase-group/list`, {withCredentials: true})
  }

  updatePhaseGroup(phaseGroup: PhaseGroup) {
    return this.http.put<PhaseGroup>(`${apiUrl}/phase-group`, phaseGroup, {withCredentials: true});
  }

  getAllPhaseGroupsBySection(
    sectionId: number,
    tradeId?: number | null,
    query?: string | null,
    sortField?: string | null,
    sortDirection?: string | null,
    page: number = 0,
    pageSize: number = 20
  ): Observable<Page<PhaseGroupListItem>> {
    let params = new HttpParams().set('sectionId', sectionId);

    if (tradeId != null) params = params.set('tradeId', tradeId);
    if (query) params = params.set('query', query);
    if (sortField) params = params.set('sortField', sortField);
    if (sortDirection) params = params.set('sortDirection', sortDirection);

    params = params.set('page', page);
    params = params.set('pageSize', pageSize);

    return this.http.get<Page<PhaseGroupListItem>>(`${apiUrl}/phase-group/list`, {
      params,
      withCredentials: true
    });
  }

  exportPhaseGroupsBySection(
    sectionId: number,
    tradeId?: number | null,
    query?: string | null,
    sortField?: string | null,
    sortDirection?: string | null
  ) {
    let params = new HttpParams().set('sectionId', sectionId);

    if (tradeId != null) params = params.set('tradeId', tradeId);
    if (query) params = params.set('query', query);
    if (sortField) params = params.set('sortField', sortField);
    if (sortDirection) params = params.set('sortDirection', sortDirection);

    return this.http.get(`${apiUrl}/phase-group/export`, {
      params,
      withCredentials: true,
      responseType: 'blob',
      observe: 'response'
    });
  }
}

export interface PhaseGroupListItem extends PhaseGroup {
  tradeName?: string;
}
